import React from 'react';

import { Grid } from '@mui/material';
import { useTheme } from '@apigrowfinance/pbolt-theme-provider';

import { RepaymentSchedule } from '@clients/domains/lending/lending';
import { RepaymentStatus } from '@enums/lending/repaymentStatus';
export interface DataVisualizationEntriesProps {
    repaymentSchedule: RepaymentSchedule[];
}

const DataVisualizationEntries = ({
    repaymentSchedule,
}: DataVisualizationEntriesProps) => {
    const { theme } = useTheme();
    return (
        <Grid container justifyContent="space-between" alignItems="center">
            {/* TODO use singleRepayment data and add hover content so more info is displayed on each entry */}
            {repaymentSchedule?.map((singleRepayment, index) => {
                const paymentHandled =
                    singleRepayment?.status === RepaymentStatus.DONE ||
                    singleRepayment?.status === RepaymentStatus.PAID ||
                    singleRepayment?.status === RepaymentStatus.PROCESSING;
                const marginLeft = index === 0 ? 0 : theme.spacing(0.25);
                const marginRight =
                    index === repaymentSchedule?.length - 1
                        ? 0
                        : theme.spacing(0.25);
                return (
                    <Grid
                        item
                        flexGrow={1}
                        mr={marginRight}
                        ml={marginLeft}
                        bgcolor={paymentHandled ? 'primary.main' : 'grey.50'}
                        height={theme.spacing(7.125)}
                        borderRadius={0.25}
                        key={`repayment-${singleRepayment?.repayment_id}`}
                        data-testid={`repayment-${singleRepayment?.repayment_id}`}
                    />
                );
            })}
        </Grid>
    );
};

export default DataVisualizationEntries;
